// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FQzk","colBig":"styles_colBig__w7M6M","colSmall":"styles_colSmall__1YYgU"};